import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const NoChangesSection = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 16px;
    padding-bottom: 16px;
`;

interface NoUpdateProps {
    isAuthenticated: boolean;
    loginUrl: string;
    customerSupportUrl: string;
}

const NoUpdateComponent = ({ isAuthenticated, loginUrl, customerSupportUrl }: NoUpdateProps) => {
    const { t } = useTranslation();

    return (<NoChangesSection id="nochanges_section">
        {isAuthenticated ? <>
            <span>
                {t('request_change_no_changes_message')}
            </span>
            {customerSupportUrl && <>
                <span>{t('request_change_need_assistance')}</span>
                <a id="customerSupportButton" className="btn subtle" href={customerSupportUrl}>{t('request_change_customer_support')}</a>
            </>}
        </>
            : <>
                <span id="packageLoginMessage">{t('request_change_not_logged_in')}</span>
                <a id="packageLoginLink" className="btn subtle" href={loginUrl}>{t('submit_logon')}</a>
            </>}
    </NoChangesSection>);
}

export default NoUpdateComponent;